import { useCallback } from 'react';
import { useStartMutation, useCheckQuestionMutation, useFinishMutation } from '../../../__generated__/chirp/com/hubspot/academy/assessments/rpc/QuizAttemptService.hooks';
import { addLessonQuizAttemptAnswerCache, clearLessonQuizAttemptCache, deleteContentProgressFromCache, setContentProgressStatusCache, setLessonQuizAttemptCache, addLessonStartQuizAttemptAnswerCache } from '../userProgress';
import { getPlaylistIdFromUrl } from '../../utils/UrlParamUtils';
import getLang from '../../utils/getLang';
import { convertToAcademyLanguage } from '../../utils/languageUtils';
export const useStartQuiz = () => {
  const [mutate, {
    loading: startQuizLoading,
    data: startQuizData,
    error: startQuizError,
    called: startQuizCalled
  }] = useStartMutation();
  const startQuiz = useCallback((quizId, language) => {
    return mutate({
      variables: {
        contentId: quizId,
        academyLanguage: convertToAcademyLanguage(language !== null && language !== void 0 ? language : getLang())
      }
    });
  }, [mutate]);
  return [startQuiz, {
    startQuizLoading,
    startQuizData,
    startQuizError,
    startQuizCalled
  }];
};
export const useSubmitAnswer = () => {
  const [mutate, {
    loading: submitQuizAnswerLoading,
    data: submitQuizAnswerData,
    error: submitQuizAnswerError,
    called: submitQuizAnswerCalled
  }] = useCheckQuestionMutation();
  const submitQuizAnswer = useCallback(({
    lessonId,
    attemptId,
    questionId,
    answerIds,
    startQuizInfo,
    trackId
  }) => {
    return mutate({
      variables: {
        attemptId,
        questionSubmission: {
          questionId,
          answerIds
        }
      },
      update(__, attempt) {
        var _attempt$data;
        if ((_attempt$data = attempt.data) !== null && _attempt$data !== void 0 && _attempt$data.result) {
          const correctAnswer = attempt.data.result.correct;
          if (startQuizInfo) {
            addLessonStartQuizAttemptAnswerCache(lessonId, attemptId, questionId, answerIds, correctAnswer, startQuizInfo, trackId);
          } else {
            addLessonQuizAttemptAnswerCache(lessonId, attemptId, questionId, answerIds, correctAnswer, trackId);
          }
        }
      }
    });
  }, [mutate]);
  return [submitQuizAnswer, {
    submitQuizAnswerLoading,
    submitQuizAnswerData,
    submitQuizAnswerError,
    submitQuizAnswerCalled
  }];
};
export const useFinishQuiz = () => {
  const [mutate, {
    loading: finishQuizLoading,
    data: finishQuizData,
    error: finishQuizError,
    called: finishQuizCalled
  }] = useFinishMutation();
  const finishQuiz = useCallback((lessonId, quizId, attemptId, trackId) => {
    const playlistId = getPlaylistIdFromUrl();
    return mutate({
      variables: {
        attemptId,
        playlistId,
        trackId
      },
      update(__, attempt) {
        var _attempt$data2;
        if ((_attempt$data2 = attempt.data) !== null && _attempt$data2 !== void 0 && _attempt$data2.result) {
          setLessonQuizAttemptCache(lessonId, quizId, attempt.data.result, trackId);
          setContentProgressStatusCache({
            trackId,
            lessonId,
            contentId: quizId,
            status: 'COMPLETED'
          });
        }
      }
    });
  }, [mutate]);
  return [finishQuiz, {
    finishQuizLoading,
    finishQuizData,
    finishQuizError,
    finishQuizCalled
  }];
};
export const useClearQuizAttempt = () => {
  return useCallback(({
    trackId,
    lessonId,
    quizId,
    attemptId
  }) => {
    clearLessonQuizAttemptCache({
      trackId,
      lessonId,
      quizId,
      attemptId
    });
    deleteContentProgressFromCache({
      trackId,
      lessonId,
      contentId: quizId
    });
  }, []);
};